











import { Component, Prop, Vue } from 'vue-property-decorator';
import { BusEvent } from '@/models/bus';
import { SimpleFileField } from '@/models/fields';
import FileUpload from '@/api/file-upload';

@Component
export default class FileUploadField extends Vue implements SimpleFileField {
  @Prop({ type: String }) public title!: string;
  @Prop() public nameRegEx?: RegExp;
  public file: File | null = null;

  public async onFileChange(name: string, files: FileList): Promise<void> {
    if (files.length === 0) {
      this.file = null;
    } else {
      const file = files.item(0);
      if (!file) {
        return;
      }

      const title = this.title ? this.title : 'File Upload';
      if (this.nameRegEx && !this.nameRegEx.test(file.name)) {
        this.$bus.$emit(
          BusEvent.ERROR,
          `${title} Error`,
          new Error(`Unsupported file format: ${file.name}`)
        );
        return;
      }
      this.file = file;
    }
  }

  public clear() {
    this.file = null;
  }

  public hasChanged(): boolean {
    return !!this.file;
  }

  /**
   * Upload the file and return a temporary file handle.
   *
   * @returns {Promise<string>}
   */
  public async upload(): Promise<string> {
    if (!this.file) {
      throw Error('Nothing to upload.');
    }

    return await FileUpload.upload(this.file);
  }
}
